import { SerializerInterface } from './SerializerInterface';

export interface SerializerFeatureServices {

  serializer: SerializerInterface;

}
